export const appendParamsIfTheyExist = (
  to,
  searchString = window.location.search,
) => {
  if (to.includes('?')) {
    return `${to}${searchString.replace('?', '')}`;
  }
  return `${to}${searchString}`;
};
